import u from "./contact-channels78.js";
function e(o) {
  "@babel/helpers - typeof";
  return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(c) {
    return typeof c;
  } : function(c) {
    return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
  }, e(o);
}
var r = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", n = "(".concat(r, "[.]){3}").concat(r), m = new RegExp("^".concat(n, "$")), t = "(?:[0-9a-fA-F]{1,4})", s = new RegExp("^(" + "(?:".concat(t, ":){7}(?:").concat(t, "|:)|") + "(?:".concat(t, ":){6}(?:").concat(n, "|:").concat(t, "|:)|") + "(?:".concat(t, ":){5}(?::").concat(n, "|(:").concat(t, "){1,2}|:)|") + "(?:".concat(t, ":){4}(?:(:").concat(t, "){0,1}:").concat(n, "|(:").concat(t, "){1,3}|:)|") + "(?:".concat(t, ":){3}(?:(:").concat(t, "){0,2}:").concat(n, "|(:").concat(t, "){1,4}|:)|") + "(?:".concat(t, ":){2}(?:(:").concat(t, "){0,3}:").concat(n, "|(:").concat(t, "){1,5}|:)|") + "(?:".concat(t, ":){1}(?:(:").concat(t, "){0,4}:").concat(n, "|(:").concat(t, "){1,6}|:)|") + "(?::((?::".concat(t, "){0,5}:").concat(n, "|(?::").concat(t, "){1,7}|:))") + ")(%[0-9a-zA-Z.]{1,})?$");
function f(o) {
  var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  u(o);
  var a = (e(c) === "object" ? c.version : arguments[1]) || "";
  return a ? a.toString() === "4" ? m.test(o) : a.toString() === "6" ? s.test(o) : !1 : f(o, {
    version: 4
  }) || f(o, {
    version: 6
  });
}
export {
  f as default
};
//# sourceMappingURL=contact-channels85.js.map
